import { Component, OnInit, Input, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
import { parseImageAttachmentUrl } from './url-parser-utils';
import { IInsightItemAttachment } from '../../models/IGlimpseReport';

@Component({
    selector: 'app-attachment',
    templateUrl: './attachment.component.html',
    styleUrls: ['./attachment.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AttachmentComponent implements OnInit {
  @Input() data: IInsightItemAttachment;
  @Input() admin: boolean = false;

  @Output() edit = new EventEmitter<IInsightItemAttachment>();
  @Output() remove = new EventEmitter<IInsightItemAttachment>();
  @Output() reelClick = new EventEmitter<IInsightItemAttachment>();

  thumbnail: string | null;

  constructor() {}

  ngOnInit() {
    const parseResult = parseImageAttachmentUrl(this.data.url);
    if (parseResult.success) {
      this.thumbnail = parseResult.url;
    }
  }
}
